import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class FSButton extends Component {
  static propTypes = {
    modalName: PropTypes.string,
    kind: PropTypes.string,
    children: PropTypes.any,
    disabled: PropTypes.bool,
    label: PropTypes.string,
    className: PropTypes.string
  }
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      focus: false
    };
  }

  onMouseDown = () => {
    if (this.buttonRef) {
      this.setState({
        active: true,
        focus: true
      });
    }
  }

  onMouseUp = () => {
    setTimeout(() => {
      if (this.buttonRef) {
        this.setState({
          active: false,
          focus: false
        });
      }
    }, 500);
  }

  render() {
    const {className, kind, label, children, disabled, ...other} = this.props;
    const allClassNames = `button ${kind ? kind : 'raised'} ${className || ''} ${disabled ? 'disabled' : ''}`;
    // there are currently 2 types of buttons: 'raised' and 'flat'
    return (
      <button className={allClassNames} {...other} onMouseUp={this.onMouseUp} onMouseDown={this.onMouseDown} onMouseLeave={this.onMouseUp} disabled={disabled} ref={node => {this.buttonRef = node;}}>
        <div className={`anim ${this.state.active ? 'active' : ''} ${this.state.focus ? 'focused' : ''}`}/>
        <span>{label}</span>
        {children}
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Button/index.js